import { EException } from 'types/response-code/zalo-point';

export const zaloPointErrorMessageInfo: Record<EException, string> = {
  '402': 'Không tìm thấy promotion',
  '400': 'Không tìm thấy Sapogo promotion',
  '401': 'Trùng tên promotion',
  '-1': 'Vui lòng kiểm tra lại thông tin'
};
